import { FC, useEffect, useState } from 'react';
import './Maintenance.scss';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { BvIcon } from 'bevi-icon';
import Spinner from '../../components/Spinner/Spinner';
import { UseService } from '../../services/Profile/UseService';
import { useMaintenance } from '../../providers/Maintenance/MaintenanceProvider';

interface MaintenanceProps { }

const Maintenance: FC<MaintenanceProps> = () => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isChecking, setIsChecking] = useState(false);

  const { handleMaintenance } = useMaintenance()

  const handleRetry = async () => {
    setIsChecking(true);
    const statusCode = await handleMaintenance();
    if (statusCode) {
      setIsChecking(false);
    } else {
      window.location.href = '/';
    }
  };

  useEffect(() => {
    const message = sessionStorage.getItem("maintenanceMessage") ||
      "O sistema está temporariamente em manutenção. Tente novamente em alguns instantes.";
    setErrorMessage(message);

    sessionStorage.removeItem("maintenanceMessage");
  }, []);

  return (
    <>
      {isChecking && <Spinner backgroundColor="white" opacity="1" />}
      <main className="Maintenance main-content mt-0" data-testid="Maintenance">
        <div className="page-header min-vh-100">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={7} className="mx-auto text-center">
                <h1 className="display-1 text-bolder text-primary"><BvIcon name="construction" variant="dark" height={90} width={90}/></h1>

                <h2>Manutenção em Andamento</h2>
                <p className="lead">{errorMessage}</p>

                <Button
                  className="btn btn-primary text-white mt-4 fadeIn2 fadeInBottom"
                  onClick={handleRetry}
                  disabled={isChecking}
                >
                  Tentar Novamente
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </main>
    </>
  );
}

export default Maintenance;